import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';
import { addModifier } from '../../player.type';

export class GladiatorTrait extends Trait {
  static baseType = TraitType.Gladiator;
  static baseTitle = 'Ludus Training';
  static baseText = 'When ending the turn with a Stance active, gain 1 Powerful.';
  static baseIcon = 'trait';

  type = GladiatorTrait.baseType;
  title = GladiatorTrait.baseTitle;
  text = GladiatorTrait.baseText;
  icon = GladiatorTrait.baseIcon;

  endTurn(): void {
    const stance = this.owner.statusEffects.find(
      (modifier: any) => modifier.type === StatusEffect.Stance,
    );
    if (stance) {
      addModifier(this.owner, StatusEffect.Powerful, 1);
    }
  }
}

TraitRegistry.register(GladiatorTrait.baseType, GladiatorTrait);
